import React from 'react';
import { IPlan } from './types';

interface IncomeRangeTableProps {
  incomeRange: { range: string }[];
  plans: IPlan[];
  startIndex: number;
  displayedIncomeRange: { range: string }[];
}

const IncomeRangeTable: React.FC<IncomeRangeTableProps> = ({
  incomeRange,
  plans,
  startIndex,
  displayedIncomeRange,
}) => {
  return (
    <>
      {incomeRange.map((item, index) => {
        const planIndex = startIndex + index;
        const currentPlan = plans?.[planIndex as number];
        const originalPrice = currentPlan?.planDetails?.pricing?.listPrice;
        const discountedPrice =
          currentPlan?.planDetails?.pricing?.discountedPrice;
        return (
          <div key={planIndex}>
            <div className="flex justify-between py-2 px-2 items-center">
              <div className="text-base font-medium sm:text-s-14">
                {item.range}
              </div>
              <div className="flex gap-3 items-center">
                {currentPlan?.coupon && (
                  <div className="text-green-700 text-s-14 font-medium">
                    -{Math.floor(currentPlan.coupon?.discountValue)}%
                  </div>
                )}
                {currentPlan?.coupon && originalPrice && (
                  <div className="text-s-14 font-medium text-gray-400 line-through">
                    ₹{`${Math.floor(originalPrice)}`}
                  </div>
                )}
                {discountedPrice !== undefined && (
                  <div className="text-base font-semibold sm:text-s-14">
                    ₹{`${Math.floor(discountedPrice)}`}
                  </div>
                )}
              </div>
            </div>
            {index < displayedIncomeRange.length - 1 && <hr />}
          </div>
        );
      })}
    </>
  );
};

export default IncomeRangeTable;
